import { FC } from 'react';

import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	ModalProps,
	rem,
	Text,
} from '@bonusly/design-system';

interface ConfirmationModalProps extends Omit<ModalProps, 'children'> {
	cancelText?: string;
	confirmText: string;
	description: string;
	header: string;
	isLoading?: boolean;
	isOpen: boolean;
	onClose: VoidFunction;
	onConfirm: VoidFunction;
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
	cancelText = 'Cancel',
	confirmText,
	description,
	header,
	isLoading,
	isOpen,
	onClose,
	onConfirm,
	...rest
}) => (
	<Modal isCentered isOpen={isOpen} onClose={onClose} size="md" {...rest}>
		<ModalOverlay />
		<ModalContent>
			<ModalHeader borderBottomWidth={rem(1)} borderColor="border.default" borderStyle="solid" color="text.default">
				{header}
			</ModalHeader>
			<ModalCloseButton size="lg" borderRadius="full" />
			<ModalBody>
				<Text>{description}</Text>
			</ModalBody>

			<ModalFooter>
				<Button variant="ghost" mr={3} onClick={onClose}>
					{cancelText}
				</Button>

				<Button isLoading={isLoading} onClick={onConfirm}>
					{confirmText}
				</Button>
			</ModalFooter>
		</ModalContent>
	</Modal>
);
